import setExtensionTimeOut from './extensionTimeout';
import {
  EXTENSION_TIMEOUT_FAILURE,
  EXTENSION_DATAURI_EMPTY
} from '../models/ScreenshotCaptureError';
import { isExtensionSupported } from '../models/ApplicationConfig';
import { getBugherd } from '../models/Application';

export default function takeScreenshot(
  requestScreenshotDataURI,
  afterScreenshot,
  legacy
) {
  return new Promise((resolve, reject) => {
    const screenshotFailure = (failure, timeOut) => {
      if (timeOut) {
        clearTimeout(timeOut);
      }
      reject(failure);
    };

    const screenshotSuccess = (details, timeOut) => {
      if (timeOut) {
        clearTimeout(timeOut);
      }
      if (details.dataURI) {
        afterScreenshot();
        resolve(details);
      } else {
        reject(EXTENSION_DATAURI_EMPTY);
      }
    };

    const extensionTimeout = setExtensionTimeOut(() =>
      screenshotFailure(EXTENSION_TIMEOUT_FAILURE)
    );

    requestScreenshotDataURI(
      {},
      details => screenshotSuccess(details, extensionTimeout),
      failure => screenshotFailure(failure, extensionTimeout),
      legacy ? getBugherd().extensionScreenshotDataURIQueue : null
    );
  });
}

export function extensionExists() {
  return isExtensionSupported();
}
